import {Controller} from "@hotwired/stimulus"
import {post} from "@rails/request.js";
// import flatpickr from "flatpickr";

// Connects to data-controller="acs--visitor"
export default class extends Controller {

    // static targets = ["visitorValidFrom", "visitorValidTo", "tenantValue", "visitorType", "tenantInfo"]
    static targets = ["tenantValue", "visitorType", "tenantInfo"]

    connect() {
        if (this.tenantValueTarget.value) {
            this.tenantDate()
        }
    }

    getSelectedValue() {
        const selected = this.visitorTypeTargets.find(type => type.checked)
        if (selected) {
            return selected.value
        }
    }

    async tenantDate() {
        let selectedValues = Array.from(this.tenantValueTarget.selectedOptions).map(option => option.value)

        const response = await post('/admin/acs/tenant_documents/tenant_document_valid_time', {
            body: {
                selected_values: JSON.stringify({selectedValues})
            },
            responseKind: 'json'
        });


        if (this.tenantValueTarget.value === "") {
            if (this.tenantInfoTarget.classList.contains("d-block")) {
                this.tenantInfoTarget.classList.replace("d-block", "d-none");
            }
        }

        let tenantInfoTarget = this.tenantInfoTarget
        let messages = [];
        if (response.ok) {
            if (this.getSelectedValue() === "client") {
                const result = await response.json;
                result.data.forEach(function (value) {
                    console.log(value)
                    const validFrom = value[0]['valid_from'];
                    const validTill = value[0]['valid_till'];
                    if (validFrom && validTill && value[0]['document_name']) {
                        messages.push(`Power of attorney for ${value[0]['document_name']} is valid from ${validFrom} to ${validTill}`)
                    }
                })
                tenantInfoTarget.textContent = messages;

                if (tenantInfoTarget.classList.contains("d-none")) {
                    tenantInfoTarget.classList.replace("d-none", "d-block");
                }

            }

        }
    }
}
